module.exports = __webpack_public_path__ + "img/humelo_logo.1a908ecc.png";